import { render, staticRenderFns } from "./UserModules.vue?vue&type=template&id=561dcc2f&scoped=true"
import script from "./UserModules.vue?vue&type=script&lang=js"
export * from "./UserModules.vue?vue&type=script&lang=js"
import style0 from "./UserModules.vue?vue&type=style&index=0&id=561dcc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dcc2f",
  null
  
)

export default component.exports